export const CalendarColorIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3999 29.4001H68.7999V60.8002C68.7999 63.0093 67.009 64.8002 64.7999 64.8002H14.3999C12.1908 64.8002 10.3999 63.0093 10.3999 60.8002V29.4001Z"
      fill="#FFA578"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.7999 16.3999H14.3999C13.2953 16.3999 12.3999 17.2953 12.3999 18.3999V60.7999C12.3999 61.9045 13.2953 62.7999 14.3999 62.7999H64.7999C65.9045 62.7999 66.7999 61.9045 66.7999 60.7999V18.3999C66.7999 17.2953 65.9045 16.3999 64.7999 16.3999ZM14.3999 14.3999C12.1908 14.3999 10.3999 16.1908 10.3999 18.3999V60.7999C10.3999 63.009 12.1908 64.7999 14.3999 64.7999H64.7999C67.009 64.7999 68.7999 63.009 68.7999 60.7999V18.3999C68.7999 16.1908 67.009 14.3999 64.7999 14.3999H14.3999Z"
      fill="#292927"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.7999 30.4L10.3999 30.4L10.3999 29.2L68.7999 29.2L68.7999 30.4Z"
      fill="#292927"
    />
    <path
      d="M21.5996 10.8C21.5996 8.81173 23.2114 7.19995 25.1996 7.19995C27.1878 7.19995 28.7996 8.81173 28.7996 10.8V19.6C28.7996 21.5882 27.1878 23.2 25.1996 23.2C23.2114 23.2 21.5996 21.5882 21.5996 19.6V10.8Z"
      fill="#FFA578"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5996 19.6V10.8C27.5996 9.47447 26.5251 8.39995 25.1996 8.39995C23.8741 8.39995 22.7996 9.47447 22.7996 10.8V19.6C22.7996 20.9254 23.8741 22 25.1996 22C26.5251 22 27.5996 20.9254 27.5996 19.6ZM25.1996 7.19995C23.2114 7.19995 21.5996 8.81173 21.5996 10.8V19.6C21.5996 21.5882 23.2114 23.2 25.1996 23.2C27.1878 23.2 28.7996 21.5882 28.7996 19.6V10.8C28.7996 8.81173 27.1878 7.19995 25.1996 7.19995Z"
      fill="#292927"
    />
    <path
      d="M50.3999 10.8C50.3999 8.81173 52.0117 7.19995 53.9999 7.19995C55.9881 7.19995 57.5999 8.81173 57.5999 10.8V19.6C57.5999 21.5882 55.9881 23.2 53.9999 23.2C52.0117 23.2 50.3999 21.5882 50.3999 19.6V10.8Z"
      fill="#FFA578"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.3999 19.6V10.8C56.3999 9.47447 55.3254 8.39995 53.9999 8.39995C52.6744 8.39995 51.5999 9.47447 51.5999 10.8V19.6C51.5999 20.9254 52.6744 22 53.9999 22C55.3254 22 56.3999 20.9254 56.3999 19.6ZM53.9999 7.19995C52.0117 7.19995 50.3999 8.81173 50.3999 10.8V19.6C50.3999 21.5882 52.0117 23.2 53.9999 23.2C55.9881 23.2 57.5999 21.5882 57.5999 19.6V10.8C57.5999 8.81173 55.9881 7.19995 53.9999 7.19995Z"
      fill="#292927"
    />
    <path
      d="M79.5999 56.9C79.5999 64.9634 73.0633 71.5 64.9999 71.5C56.9365 71.5 50.3999 64.9634 50.3999 56.9C50.3999 48.8367 56.9365 42.3 64.9999 42.3C73.0633 42.3 79.5999 48.8367 79.5999 56.9Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.9999 69.5C71.9587 69.5 77.5999 63.8588 77.5999 56.9C77.5999 49.9413 71.9587 44.3 64.9999 44.3C58.0411 44.3 52.3999 49.9413 52.3999 56.9C52.3999 63.8588 58.0411 69.5 64.9999 69.5ZM64.9999 71.5C73.0633 71.5 79.5999 64.9634 79.5999 56.9C79.5999 48.8367 73.0633 42.3 64.9999 42.3C56.9365 42.3 50.3999 48.8367 50.3999 56.9C50.3999 64.9634 56.9365 71.5 64.9999 71.5Z"
      fill="#292927"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.9999 46.6001C65.3313 46.6001 65.5999 46.8687 65.5999 47.2001V56.3001H74.6999C75.0313 56.3001 75.2999 56.5687 75.2999 56.9001C75.2999 57.2315 75.0313 57.5001 74.6999 57.5001H64.9999C64.6685 57.5001 64.3999 57.2315 64.3999 56.9001V47.2001C64.3999 46.8687 64.6685 46.6001 64.9999 46.6001Z"
      fill="#292927"
    />
  </svg>
);
